export { default } from './SectionCarouselItem';
